// Modal.js

import React, { useEffect, useState } from "react";
import DynamicTextArea from "../../DynamicTextArea";
import { useTranslation } from "react-i18next";
import { SourceDto, SpellDto } from "../../../Types/ApiTypes";
import { getTranslation } from "../../../Utils/Converters";
import { getAllSources } from "../../../Utils/LocalApi";

interface SpellModalTabProps{
    spell: SpellDto,
    setSpell: (spell: SpellDto) => void,
    language: string
}

const SpellModalTab = (props: SpellModalTabProps) => {
    const { t } = useTranslation();
    const [allSources, setAllSources] = useState([] as SourceDto[])
    useEffect(() => {
        getAllSources().then(setAllSources);
    },[]);
    return (
        <div>
            <div className="d-flex flex-wrap text-center">
                <div className="d-flex col-3 p-2">
                    <span className="col-4 pe-2"><b>{t("spellmodal-index")}</b></span>
                    <span className="col-8"><input 
                        value={props.spell.index}
                        type="text"
                        className="form-control"
                        name="index"
                        onChange={(e) => {
                            props.spell.index = e.target.value;
                            props.setSpell({...props.spell})
                        }}
                    ></input></span>
                </div>
                <div className="d-flex col-3 p-2">
                    <span className="col-4 pe-2"><b>{t("spellmodal-source")}</b></span>
                    <span className="col-8">
                        <select 
                            value={props.spell.source ? props.spell.source.id : 0}
                            className="form-control"
                            name="index"
                            onChange={(e) => {
                                props.spell.source = allSources.filter(s => {return s.id! === parseInt(e.target.value)})[0];
                                props.setSpell({...props.spell})
                            }}
                        >
                            {allSources.map((source) => {
                                return(
                                    <option key={source.id} value={source.id}>{(source.year > 0 ? source.year : "")+" "+getTranslation(source.name, props.language)}</option>
                                )
                            })}
                        </select>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-name")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.name, props.language)}
                                type="text"
                                className="form-control"
                                name="name-en"
                                onChange={(e) => {
                                    props.spell.name[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2"><b>{t("spellmodal-level")}</b></span>
                    <span className="col-2"><input 
                        value={props.spell.level}
                        type="number"
                        className="col-6 form-control text-center"
                        name="level"
                        onChange={(e) => props.setSpell({...props.spell,"level": parseInt(e.target.value)})}
                    ></input></span>
                    <span className="col-3"><b>{t("spellmodal-ritual")}</b></span>
                    <span className="col-1">
                        <span className="form-control">
                            <input 
                                type="checkbox"
                                checked={props.spell.ritual}
                                name="v"
                                onChange={e => {
                                    props.setSpell({...props.spell,"ritual": e.target.checked});
                                }}
                            ></input>
                        </span>
                    </span>
                    <span className="col-3"><b>{t("spellmodal-concentration")}</b></span>
                    <span className="col-1">
                        <span className="form-control">
                            <input 
                                type="checkbox"
                                checked={props.spell.concentration}
                                name="v"
                                onChange={e => {
                                    props.setSpell({...props.spell,"concentration":  e.target.checked});
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-castingtime")}</b></span>
                    <span className="col-4">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.castingTime, props.language)}
                                type="text"
                                className="form-control"
                                name="castingTime-en"
                                onChange={(e) => {
                                    props.spell.castingTime[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                    <span className="col-2 pe-2"><b>{t("spellmodal-duration")}</b></span>
                    <span className="col-4">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.duration, props.language)}
                                type="text"
                                className="form-control"
                                name="duration-en"
                                onChange={(e) => {
                                    props.spell.duration[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>

                <div className="d-flex col-6 p-2">
                    <span className="col-2"><b>{t("spellmodal-components")}</b></span>
                    <span className="col-3">
                        <span className="input-group d-flex">
                            <span className="input-group-text">V&nbsp;&nbsp;
                                <input 
                                    type="checkbox"
                                    checked={props.spell.components.v}
                                    name="v"
                                    onChange={e => {
                                        props.setSpell({...props.spell,"components": {"v": e.target.checked,"s":props.spell.components.s,"m":props.spell.components.m}});
                                    }}
                                ></input>
                            </span>
                            <span className="input-group-text">S&nbsp;&nbsp;
                                <input 
                                    checked={props.spell.components.s}
                                    name="s"
                                    type="checkbox"
                                    onChange={e => {
                                        props.setSpell({...props.spell,"components": {"v": props.spell.components.v,"s":e.target.checked,"m":props.spell.components.m}});
                                    }}
                                ></input>
                            </span>
                            <span className="input-group-text">M&nbsp;&nbsp;
                                <input 
                                    checked={props.spell.components.m}
                                    name="m"
                                    type="checkbox"
                                    onChange={e => {
                                        props.setSpell({...props.spell,"components": {"v": props.spell.components.v,"s":props.spell.components.s,"m":e.target.checked}});
                                    }}
                                ></input>
                            </span>
                        </span>
                    </span>
                    <span className="col-2"><b>{t("spellmodal-material")}</b></span>
                    <span className="col-5">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.materials, props.language)}
                                type="text"
                                className="form-control"
                                name="materials-en"
                                onChange={(e) => {
                                    props.spell.materials[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-school")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.school, props.language)}
                                type="text"
                                className="form-control"
                                name="school-en"
                                onChange={(e) => {
                                    props.spell.school[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>

                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-range")}</b></span>
                    <span className="input-group">
                        <input 
                            value={props.spell.range? props.spell.range.mt : 0}
                            type="number"
                            className="form-control text-center"
                            name="rangeAreaM"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                props.setSpell({...props.spell,"range": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                            }}
                        ></input>
                        <span className="input-group-text">m</span>
                        <input 
                            value={props.spell.range? props.spell.range.ft : 0}
                            name="rangeAreaFt"
                            type="number"
                            className="form-control text-center"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                props.setSpell({...props.spell,"range": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                            }}
                        ></input>
                        <span className="input-group-text">ft</span>
                        <input 
                            value={props.spell.range? props.spell.range.sq : 0}
                            name="rangeAreaSq"
                            type="number"
                            className="form-control text-center"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                props.setSpell({...props.spell,"range": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                            }}
                        ></input>
                        <span className="input-group-text">{t("sq")}</span>
                    </span>
                </div>
                
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-otherrange")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.otherRange, props.language)}
                                type="text"
                                className="form-control"
                                name="otherRange-en"
                                onChange={(e) => {
                                    props.spell.otherRange[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
    
                        </span>
                    </span>
                </div>
                
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-attacktype")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.attackType, props.language)}
                                type="text"
                                className="form-control"
                                name="attackType-en"
                                onChange={(e) => {
                                    props.spell.attackType[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-damagetype")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.damageType, props.language)}
                                type="text"
                                className="form-control"
                                name="damageType-en"
                                onChange={(e) => {
                                    props.spell.damageType[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-dctype")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.dcType, props.language)}
                                type="text"
                                className="form-control"
                                name="dcType-en"
                                onChange={(e) => {
                                    props.spell.dcType[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-dcsuccess")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={props.spell.dcSuccess ? getTranslation(props.spell.dcSuccess, props.language) : ""}
                                type="text"
                                className="form-control"
                                name="dcSuccess-en"
                                onChange={(e) => {
                                    props.spell.dcSuccess[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-aoetype")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.areaOfEffectType, props.language)}
                                type="text"
                                className="form-control"
                                name="areaOfEffectType-en"
                                onChange={(e) => {
                                    props.spell.areaOfEffectType[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-aoesize")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <span className="input-group">
                                <input 
                                    value={props.spell.areaOfEffectSize? props.spell.areaOfEffectSize.mt : 0}
                                    type="number"
                                    className="form-control text-center"
                                    name="areaOfEffectSize-m"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setSpell({...props.spell,"areaOfEffectSize": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">m</span>
                                <input 
                                    value={props.spell.areaOfEffectSize? props.spell.areaOfEffectSize.ft : 0}
                                    name="areaOfEffectSize-ft"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setSpell({...props.spell,"areaOfEffectSize": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">ft</span>
                                <input 
                                    value={props.spell.areaOfEffectSize? props.spell.areaOfEffectSize.sq : 0}
                                    name="areaOfEffectSize-sq"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setSpell({...props.spell,"areaOfEffectSize": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("sq")}</span>
                            </span>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-classes")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.classes, props.language)}
                                type="text"
                                className="form-control"
                                name="classes-en"
                                onChange={(e) => {
                                    props.spell.classes[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
                <div className="d-flex col-6 p-2">
                    <span className="col-2 pe-2"><b>{t("spellmodal-subclasses")}</b></span>
                    <span className="col-10">
                        <span className="input-group">
                            <input 
                                value={getTranslation(props.spell.subclasses, props.language)}
                                type="text"
                                className="form-control"
                                name="subclasses-en"
                                onChange={(e) => {
                                    props.spell.subclasses[props.language] = e.target.value;
                                    props.setSpell({...props.spell})
                                }}
                            ></input>
                        </span>
                    </span>
                </div>
            </div>
            <div className="p-4">
                <span className="pe-2"><b>{t("spellmodal-description")}</b></span>
                <div className="d-flex">
                    <span className="col-12">
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.spell.description[props.language] = text;
                                props.setSpell({...props.spell})
                            }}      
                            placeholder={t("placeholder-spelldescription")}
                            areaText={props.spell.description ? getTranslation(props.spell.description, props.language) : ""}/>
                    </span>
                </div>
                <span className="pe-2"><b>{t("spellmodal-higherlevel")}</b></span>
                <div className="d-flex">
                    <span className="col-12">
                        <DynamicTextArea
                            updateText={(text: string)=>{
                                props.spell.higherLevel[props.language] = text;
                                props.setSpell({...props.spell})
                            }}      
                            placeholder={t("placeholder-spellhigherlevel")}
                            areaText={props.spell.higherLevel ? getTranslation(props.spell.higherLevel, props.language) : ""}/>
                    </span>
                </div>
            </div>
        </div>

    )
}
export default SpellModalTab;